import { APPOINTMENT_REQUEST_CALENDAR, SCREEN, HOST_TYPE_ONE_ON_ONE, HOST_TYPE_ROUND_ROBIN, HOST_TYPE_COLLECTIVE } from '../../utils/constants';
import { doFoCus, goToProviderScheduleLink, navigate, params } from './movePages';
import {
    surgicalOption,
    setSurgicalOption,
    isBookAppointment,
    form,
    setLocationId,
    locations,
    setIsBookAppointment,
    procedures,
    consultationNonSurgicalPath,
    staffId,
    providers,
    staffs,
    procedureIdSelected,
    setProcedureId,
    appointmentChannelId,
    setProcedures,
    providerId,
    hiddenPages,
} from '../../utils/variables';
import { loadSelectSearchProcedure } from '../../views/components/selectSearchProcedure';
import { newPhoneUI } from '../actions/phoneActions';
import { fetchProcedureByStaff } from './providersListeners';
import { patientContinueBtnHandler, patientListeners } from './patientListeners';
import { goToServices } from './validateDigitsListeners';
import { isPageHidden } from '../../utils/checkHiddenPage';

export function surgicalListeners() {
    /* on select surgical*/
    clickSurgicalOptionListener();

    /* on click back button */
    document
        .querySelectorAll('.procedure__price-duration')
        .forEach((j) => j.classList.remove('procedure__price-duration--show'));
}

function clickSurgicalOptionListener() {
    document
        .getElementById('button--surgical')
        .addEventListener('click', handleSurgicalButtonClick);
    document
        .getElementById('button--non-surgical')
        .addEventListener('click', handleNonSurgicalButtonClick);
    document
        .querySelector('.surgical-option__btn')
        ?.addEventListener('click', onClickSurgicalOptionAction);
}

async function onClickSurgicalOptionAction() {
    setLocationId(locations[0]?.id);
    if (surgicalOption) {
        if (form.appointment_request_type === APPOINTMENT_REQUEST_CALENDAR) {
            if (isBookAppointment) {
                if (isPageHidden('patient_page', hiddenPages)) {
                    patientContinueBtnHandler()
                } else {
                    patientListeners();
                    navigate(SCREEN.PATIENTS);
                }
            }
        } else {
            if (staffId) {
                await fetchProcedureByStaff(+staffId);
            }
            loadSelectSearchProcedure(procedures);
            navigate(SCREEN.REQUEST_CONSULT);
        }
    } else {
        if (consultationNonSurgicalPath) {
            window.open(consultationNonSurgicalPath, '_blank');
        } else {
            if (form.appointment_request_type === APPOINTMENT_REQUEST_CALENDAR) {
                if (isBookAppointment) {
                    if (isPageHidden('patient_page', hiddenPages)) {
                        patientContinueBtnHandler()
                    } else {
                        patientListeners();
                        navigate(SCREEN.PATIENTS);
                    }
                }
            } else {
                if (staffId) {
                    await fetchProcedureByStaff(+staffId);
                }
                loadSelectSearchProcedure(procedures);
                navigate(SCREEN.REQUEST_CONSULT);
            }
        }
    }

    checkStaffExist();
}

export function removeStyleSurgicalOptionSelected(isSurgical) {
    let btnIdName = isSurgical ? 'button--surgical' : 'button--non-surgical';
    document
        .getElementById(btnIdName)
        .classList.remove('surgical-option--selected');
    document
        .querySelectorAll(`#${btnIdName} .title-wrapper span`)
        .forEach((e) => {
            e.classList.remove('surgical-option__title--selected');
        });
    document
        .querySelector(`#${btnIdName} .icon__background`)
        ?.classList.remove('surgical-option__icon-wrapper--selected');
    document
        .querySelector(`#${btnIdName} .icon__background .icon--svg path`)
        ?.classList.remove('surgical-option__icon--selected');
}

function addStyleSurgicalOptionSelected(isSurgical) {
    let btnIdName = isSurgical ? 'button--surgical' : 'button--non-surgical';
    document
        .getElementById(btnIdName)
        .classList.add('surgical-option--selected');
    document
        .querySelectorAll(`#${btnIdName} .title-wrapper span`)
        .forEach((e) => {
            e.classList.add('surgical-option__title--selected');
        });
    document
        .querySelector(`#${btnIdName} .icon__background`)
        .classList.add('surgical-option__icon-wrapper--selected');
    document
        .querySelector(`#${btnIdName} .icon__background .icon--svg path`)
        ?.classList.add('surgical-option__icon--selected');
}

export async function handleSurgicalButtonClick() {
    setLocationId(locations[0]?.id);
    if (surgicalOption === null || surgicalOption === false) {
        addStyleSurgicalOptionSelected(true);
        removeStyleSurgicalOptionSelected(false);
        setSurgicalOption(true);
        setIsBookAppointment(true);

        const checkStaffId = form?.staff?.findIndex(staff => staff.id === +staffId);
        if (staffId && checkStaffId < 0) {
            return
        }

        if (checkStaffId >= 0 && staffId) {
            const id = appointmentChannelId && form?.appointment_channel?.procedures?.length > 1 ? providerId : staffId;
            if (!appointmentChannelId) {
                await fetchProcedureByStaff(id ?? +staffId);
            }
        }

        if (
            form.appointment_request_type ===
            APPOINTMENT_REQUEST_CALENDAR || appointmentChannelId
        ) {
            if (isBookAppointment || appointmentChannelId) {
                if (appointmentChannelId) {
                    const hostType = form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
                    const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
                    const staffCount = staffsOfAppointmentChannel?.length || 0;

                    const isProviderFirst = form?.appointment_channel?.is_select_provider_first;

                    if (hostType === HOST_TYPE_ONE_ON_ONE && staffCount > 1) {
                        if (isProviderFirst) {
                            goToProviderScheduleLink()
                        } else {
                            goToServices()
                        }
                    } else {
                        goToServices()
                    }

                } else {
                    if (isPageHidden('patient_page', hiddenPages)) {
                        patientContinueBtnHandler()
                    } else {
                        patientListeners();
                        navigate(SCREEN.PATIENTS);
                    }
                }
            }
        } else {
            preSelectProcedure();
            if (staffId) {
                if (checkStaffId >= 0) {
                    loadSelectSearchProcedure(procedures);
                    navigate(SCREEN.REQUEST_CONSULT);
                }
            } else {
                loadSelectSearchProcedure(procedures);
                navigate(SCREEN.REQUEST_CONSULT);
            }
        }
    } else if (surgicalOption) {
        removeStyleSurgicalOptionSelected(true);
        removeStyleSurgicalOptionSelected(false);
        setSurgicalOption(null);
    }

    checkStaffExist();
}

export async function handleNonSurgicalButtonClick() {
    setLocationId(locations[0]?.id);
    if (surgicalOption === null || surgicalOption === true) {
        addStyleSurgicalOptionSelected(false);
        removeStyleSurgicalOptionSelected(true);
        setSurgicalOption(false);
        setIsBookAppointment(true);

        const checkStaffId = form?.staff?.findIndex(staff => staff.id === +staffId);
        if (staffId && checkStaffId < 0) {
            return
        }

        if (checkStaffId >= 0 && staffId) {
            const id = appointmentChannelId && form?.appointment_channel?.procedures?.length > 1 ? providerId : staffId;
            if (!appointmentChannelId) {
                await fetchProcedureByStaff(id ?? +staffId);
            }
        }

        if (consultationNonSurgicalPath) {
            window.open(consultationNonSurgicalPath, '_blank');
        } else {
            if (
                form.appointment_request_type ===
                APPOINTMENT_REQUEST_CALENDAR || appointmentChannelId
            ) {
                if (appointmentChannelId) {
                    const hostType = form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
                    const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
                    const staffCount = staffsOfAppointmentChannel?.length || 0;
                    const isProviderFirst = form?.appointment_channel?.is_select_provider_first;

                    if (hostType === HOST_TYPE_ONE_ON_ONE && staffCount > 1) {
                        if (isProviderFirst) {
                            goToProviderScheduleLink()
                        } else {
                            goToServices()
                        }
                    } else {
                        goToServices()
                    }

                } else {
                    if (isPageHidden('patient_page', hiddenPages)) {
                        patientContinueBtnHandler()
                    } else {
                        patientListeners();
                        navigate(SCREEN.PATIENTS);
                    }
                }
            } else {
                preSelectProcedure();
                if (staffId) {
                    if (checkStaffId >= 0) {
                        loadSelectSearchProcedure(procedures);
                        navigate(SCREEN.REQUEST_CONSULT);
                    }
                } else {
                    loadSelectSearchProcedure(procedures);
                    navigate(SCREEN.REQUEST_CONSULT);
                }
            }
        }
    } else {
        removeStyleSurgicalOptionSelected(true);
        removeStyleSurgicalOptionSelected(false);
        setSurgicalOption(null);
    }

    checkStaffExist();
}

export async function handleBothSurgicalOptionsClick() {
    setLocationId(locations[0]?.id);

    removeStyleSurgicalOptionSelected(true);
    removeStyleSurgicalOptionSelected(false);
    setSurgicalOption(null);

    setIsBookAppointment(true);

    const checkStaffId = form?.staff?.findIndex(staff => staff.id === +staffId);
    if (staffId && checkStaffId < 0) {
        return
    }

    if (checkStaffId >= 0 && staffId) {
        const id = appointmentChannelId && form?.appointment_channel?.procedures?.length > 1 ? providerId : staffId;
        if (!appointmentChannelId) {
            await fetchProcedureByStaff(id ?? +staffId);
        }
    }

    if (
        form.appointment_request_type ===
        APPOINTMENT_REQUEST_CALENDAR || appointmentChannelId
    ) {
        if (isBookAppointment || appointmentChannelId) {
            if (appointmentChannelId) {
                const hostType = form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
                const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
                const staffCount = staffsOfAppointmentChannel?.length || 0;
                const isProviderFirst = form?.appointment_channel?.is_select_provider_first;

                if (hostType === HOST_TYPE_ONE_ON_ONE && staffCount > 1) {
                    if (isProviderFirst) {
                        goToProviderScheduleLink()
                    } else {
                        goToServices()
                    }
                } else {
                    goToServices()
                }

            } else {
                if (isPageHidden('patient_page', hiddenPages)) {
                    patientContinueBtnHandler()
                } else {
                    patientListeners();
                    navigate(SCREEN.PATIENTS);
                }
            }
        }
    } else {
        preSelectProcedure();
        if (staffId) {
            if (checkStaffId >= 0) {
                loadSelectSearchProcedure(procedures);
                navigate(SCREEN.REQUEST_CONSULT);
            }
        } else {
            loadSelectSearchProcedure(procedures);
            navigate(SCREEN.REQUEST_CONSULT);
        }
    }

    checkStaffExist();
}


function checkStaffExist() {
    if (staffId) {
        const btnContinue = document.querySelector(".surgical__container  .surgical-option__btn");
        const provider = providers?.find(p => p.id === +staffId);
        btnContinue?.classList.toggle("disabled", !provider);
    }
}

export const preSelectProcedure = () => {
    if (procedureIdSelected) {
        const foundProcedure = procedures?.find(i => i?.id === +procedureIdSelected)
        if (foundProcedure) {
            setProcedureId(procedureIdSelected)
            if (!foundProcedure?.name) return
            document.querySelector('#procedureConsult').value = foundProcedure?.name || "";
            document?.querySelector(".requestConsult__container .procedure__wrapper")?.classList?.add("isSelectedByIdParams")

        } else {
            document?.querySelector(".requestConsult__container .procedure__wrapper")?.classList?.remove("isSelectedByIdParams")
        }
    } else {
        document?.querySelector(".requestConsult__container .procedure__wrapper")?.classList?.remove("isSelectedByIdParams")
    }
}